import {axios} from "@/utils/request";
const api = {
  source: '/order/DispatchOrder',
  enterprise:'/enterprise',
  team: '/master/app/team',
  orderApp:'/order/orderApp',
}
// 查询匹配订单信息
export function getselectPriceName (parameter) {
  return axios({
    url: api.source +  '/selectPriceName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export function reDispatch (parameter) {
  return axios({
    url: api.orderApp +  '/reDispatch',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单添加配件查询企业可用配件
export function getselectAreaPrincipalList (parameter) {
  return axios({
    url: api.source +'/selectAreaPrincipalList',
    method: 'get',
    params: parameter,
  })
}

export function getselectPriceNameForFirstPage (parameter) {
  return axios({
    url: api.source +'/selectPriceNameForFirstPage',
    method: 'get',
    params: parameter,
  })
}


export function getmasterList (parameter) {
  return axios({
    url: api.team +'/teamMemberList',
    method: 'get',
    params: parameter,
  })
}
export function getmasterListForFirstPage(parameter) {
  return axios({
    url: api.source +'/masterListForFirstPage',
    method: 'get',
    params: parameter,
  })
}
export function gethistoryMaster (parameter) {
  return axios({
    url: api.source +'/historyMaster',
    method: 'get',
    params: parameter,
  })
}